export const DEPARTURE_CITY_TEXTS = {
  fieldLabelFixed: 'Откуда',
  nothingFound: 'Ничего не найдено',
  nothingFoundHint: 'Ничего не нашли. Проверьте, правильно \n ли вы написали название',
  searchPlaceholder: 'Город вылета',
  errorEmpty: 'Выберите город вылета',
} as const;
